import React from 'react';

import MuiSelect, { SelectProps as MuiSelectProps } from '@material-ui/core/Select';

export interface SelectProps extends MuiSelectProps {
  name: string;
}

const Select: React.FC<SelectProps> = ({ inputProps, name, ...rest }) => (
  <MuiSelect
    name={name}
    data-lh-id={`select-${name}`}
    inputProps={{
      'data-lh-id': `select-input-${name}`,
      ...inputProps,
    }}
    {...rest}
  />
);

export default Select;
